import React from "react";
import { Card, CardBody, Row, Col, Container } from "reactstrap";
import { SettingsCategoryList } from "./SettingsCategoryList";

type Props = {
  title: string;
  selectedCategory: any;
  settingCategories: any[];
  onCategoryChange: (category: any) => void;
};

export const SettingsContainer: React.FC<Props> = props => (
  <Container fluid>
    <h2>{props.title}</h2>
    <br />
    <Row>
      <Col xs="auto">
        <SettingsCategoryList
          selectedCategory={props.selectedCategory}
          settingCategories={props.settingCategories}
          onSelection={props.onCategoryChange}
        />
      </Col>
      <Col>
        <Card>
          <CardBody>
            <h4>{props.selectedCategory}</h4>
            <br />
            {props.children}
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
);
